import { Effect } from 'effect';

import { getProductsByCodes } from '../../bind/product';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';
import { tagged } from '@vs-shop/engine/data/util/tagged';

type FetchProductsByCodesKey = {
  readonly _tag: 'FetchProductsByCodesKey';
  readonly codes: readonly string[];
  readonly page: number;
  readonly itemsPerPage: number;
};

const FetchProductsByCodesKey = tagged<FetchProductsByCodesKey>('FetchProductsByCodesKey');

const fetchProductsByCodesAtomFamily = Atom.family((key: FetchProductsByCodesKey) => {
  return RuntimeClientAtom.atom(
    Effect.gen(function* () {
      const { codes, page, itemsPerPage } = key;

      return yield* getProductsByCodes({
        codes: Array.from(codes),
        page,
        itemsPerPage,
      });
    })
  ).pipe(Atom.keepAlive);
});

export const fetchProductsByCodesPageAtom = (
  codes: readonly string[],
  page: number,
  itemsPerPage: number
) => {
  const key = FetchProductsByCodesKey({ codes, page, itemsPerPage });

  return fetchProductsByCodesAtomFamily(key);
};
